import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';


import { CmsService, OccEndpointsService } from '@spartacus/core';
import { combineLatest, Observable } from 'rxjs';
import { map, mergeMap } from 'rxjs/operators';

import { DpUrlService } from '@app/core/services/url.service';
import { CarouselItem } from '@app/ui-components/carousel/types';
import { AnnouncementItemComponent, NewsItem, NewsList } from '@app-modules/news/types';

@Injectable({ providedIn: 'root' })
export class DpNewsService {
  readonly #cmsService = inject(CmsService);

  constructor(
    private readonly httpClient: HttpClient,
    private readonly dpUrlService: DpUrlService,
    private readonly occEndpoints: OccEndpointsService
  ) {}

  private static get defaultHeadersFactory(): HttpHeaders {
    return new HttpHeaders({
      accept: 'application/json'
    });
  }

  getNewsDetails(newsId?: string): Observable<NewsItem> {
    return this.dpUrlService.urlParts$.pipe(
      mergeMap(({ market }) =>
        this.httpClient.get<NewsItem>(`${this.dpUrlService.API_ROUTE}/${market}/news/${newsId ?? ''}`, {
          headers: DpNewsService.defaultHeadersFactory
        })
      )
    );
  }

  getAllNews(): Observable<NewsList> {
    return this.httpClient.get<NewsList>(this.occEndpoints.buildUrl('news'));
  }

  getLatestNews(): Observable<CarouselItem[]> {
    return this.httpClient.get<NewsList>(this.occEndpoints.buildUrl('news/latest')).pipe(
      map(({ newsList }) =>
        newsList.map(({ image, label, creationDate, newsTitle }) => ({
          image,
          creationDate,
          description: newsTitle && newsTitle?.length > 100 ? newsTitle?.substring(0, 100) + '...' : newsTitle || '',
          link: { url: label }
        }))
      )
    );
  }

  getOffers(fields: string): Observable<CarouselItem[]> {
    return combineLatest(
      fields.split(' ').map((field: string) =>
        this.#cmsService.getComponentData<AnnouncementItemComponent>(field).pipe(
          map((item: AnnouncementItemComponent) => ({
            image: item?.image,
            description: item?.longDescription || '',
            creationDate: item.modifiedTime,
            link: {
              url: item.buttonLink?.url,
              label: item.buttonLink?.linkName
            }
          }))
        )
      )
    );
  }
}
